import React from "react";
import { Container, Box } from "@mui/material";

const Layout = ({ children }) => {
	return (
		<Container>
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					padding: "0 20px",
					alignItems: "center"
				}}
			>
				{children}
			</Box>
		</Container>
	);
};

export default Layout;
